module.exports = __webpack_public_path__ + "310325644f4ad7497374f330d6c15fd4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svg/globoLoteria.svg
// module id = 361
// module chunks = 0